module.exports = __webpack_public_path__ + "36ea2db30d18cd04607a172d9d147da8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PE.svg
// module id = jLKQ
// module chunks = 0